import React from 'react';

function DistributeSection() {
    let tvImage = "./assets/images/landing/distributeFloat.webp?t=" + Date.now();
    return (
        <section className="partnership-section distribute-section">
            <div className="distribute-bg-cont">
                <img
                    src={tvImage}
                    className="distribute-bg-img"
                    alt=""
                />
            </div>
        
            <div className="distribute-content">
                <div className="row">
                    <div className="col-lg-6">
                        <h2 className="mb-4 partnership-title">
                            Distribute. Earn. Entertain.
                        </h2>
                        <p className="partnership-desc">
                            Whether you're a production studio or an independent creator,
                            Fawesome helps you unlock new audiences and monetize your content —
                            from movies and web series to documentaries, shorts, and YouTube videos.
                            Fawesome is one of the most transparent and creator-friendly AVOD streaming platforms.
                        </p>
                    </div>
                </div>
            </div>

            {/* DIVFOOTER 2 - Bottom transition divider */}
            <div className="partnership-footer-divider partnership-footer-divider-distribute">
                <img
                    src="/assets/images/divfooter2.svg"
                    alt=""
                    className="img-fluid"
                />
            </div>
        </section>
    );
}


export default DistributeSection;
